import { useTranslation } from 'react-i18next';

import { partitionInviteesByMatrixUserExistence } from 'components/InviteInput/partitionInviteesByMatrixUserExistence';
import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import useToast from 'contexts/ToastProvider/useToast';

const useMatrixInviteeValidation = () => {
  const { t } = useTranslation();
  const { pushToast } = useToast();
  const { matrixClient } = useMatrixContext();

  const filterInvalidMatrixInvitees = async (invitees: string[]): Promise<string[]> => {
    const { validInvitees, invalidMatrixIds } = await partitionInviteesByMatrixUserExistence(matrixClient, invitees);

    if (invalidMatrixIds.length > 0) {
      pushToast({
        variant: 'warning',
        title: t('messenger.invalid_matrix_ids_not_invited', { users: invalidMatrixIds.join(', ') }),
      });
    }

    return validInvitees;
  };

  return { filterInvalidMatrixInvitees };
};

export default useMatrixInviteeValidation;
